import Spinner from "../components/common/spinner/spinner";
import { useCentralStore } from "../store/appContext";
import Dashboard from "./dashboard/dashboard";
import AsurionLogo from '../assets/icons/asurionLogo'

const Application = () => {
  const [{ loading, loadingData }] = useCentralStore();
  return (
    <>
      {(loading || loadingData) && <Spinner showOverlay={true} />}
        <div>
          <Dashboard />
          <div className="flex justify-center items-center">
             <p className="text-black mr-1 font-bold">Powered by</p>
             <AsurionLogo className="text-center my-4" />
            </div>
        </div>
    </>
  );
};

export default Application;
